export const LOGIN_BEGIN = "LOGIN_BEGIN";
export const LOGIN_END = "LOGIN_END";
export const SET_USER = "SET_USER";
